export const DEFAULT_ATTACHMENT_FILES = [
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/msword',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/rtf',
  'text/rtf',
  'text/plain',
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/bmp',
  'image/tiff',
  'application/zip',
  'application/x-zip-compressed',
  'application/x-tar',
  'application/gzip',
  '.rtf',
  '.gz',
];

// Removed the basic and scorecard attachment files as they are not needed anymore now we support all file types

// export const BASIC_ATTACHMENT_FILES = [
//   'application/pdf',
//   'application/msword',
//   'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
// ];

// // Scorecard attachment file types (PDF, Word, Images)
// export const SCORECARD_ATTACHMENT_FILES = [
//   'application/pdf',
//   'application/msword',
//   'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
//   'image/jpeg',
//   'image/jpg',
//   'image/png',
// ];
